import { defineNuxtPlugin } from '#app'
import { i18n } from '~/translations'

export default defineNuxtPlugin(app => void app.vueApp.use(i18n))
